import React, { useEffect } from 'react';
import { useCreateProjectPermission } from '@atlassian/jira-nav-item-service/src/services/create-project-permisson/index.tsx';
import { ProjectCreateDrawerConsumer } from '@atlassian/jira-project-create-drawer-context/src/index.tsx';
import type { OpenDrawerMethod } from '@atlassian/jira-project-create-drawer/src/types.tsx';
import { useSwitchModals } from '@atlassian/jira-switch-modals-controller/src/index.tsx';
import { MODAL_ID } from '@atlassian/jira-atlassian-navigation/src/common/constants.tsx';

export const ProjectCreateDrawerOpener = ({
	open,
	close,
	setOnCloseCallback,
}: {
	open?: OpenDrawerMethod;
	close: () => void;
	setOnCloseCallback: (close: () => void) => void;
}) => {
	const [{ canCreateClassicProject }] = useCreateProjectPermission();

	useEffect(() => {
		open &&
			open({
				source: 'navigationNext',
				isNextGen: !canCreateClassicProject,
			});

		setOnCloseCallback && setOnCloseCallback(close);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return null;
};

export const Projects = () => {
	const [isProjectCreateDrawerOpen, { off: closeProjectCreateDrawer }] = useSwitchModals(
		MODAL_ID.PROJECT_CREATE,
	);

	if (!isProjectCreateDrawerOpen) {
		return null;
	}

	// ProjectCreateDrawerProvider is in page container/navigaiton
	return (
		<ProjectCreateDrawerConsumer>
			{({ methods: { open, setOnCloseCallback } }) => (
				<ProjectCreateDrawerOpener
					open={open}
					close={closeProjectCreateDrawer}
					setOnCloseCallback={setOnCloseCallback}
				/>
			)}
		</ProjectCreateDrawerConsumer>
	);
};
